import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 70vw;
  height: 90vh;
  background: #fff;
  border-radius: 0.17648rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  padding-left: 1.77375rem;

  position: relative;

  .ReactCollapse--collapse {
    transition: height 500ms;
  }
`;

export const TableContainer = styled.div`
  overflow-y: auto;
  width: 70%;
  min-width: 20rem;
  max-height: 50%;
  border: 1px solid #c4c4c4;

  ::-webkit-scrollbar {
    width: 0.25rem;
  }
  ::-webkit-scrollbar-thumb {
    background: lightgray;
  }
`;

export const Table = styled.table`
  border-collapse: collapse;
  width: 100%;

  td {
    padding: 0.3rem;
  }

  thead {
    th {
      text-align: start;
      color: #fff;
      background: #585e66;
      position: sticky;
      z-index: 5;
      top: 0;
    }
  }
`;

export const THSel = styled.th`
  max-width: 10%;
`;

export const THLabel = styled.th`
  width: 30%;
`;

export const THStatus = styled.th`
  max-width: 20%;
`;

export const THACC = styled.th`
  min-width: 35%;
`;

export const TRLine = styled.tr`
  font-size: 0.85rem;
  background: ${({ checked }) => (checked ? "#cff8e7" : "#fff")};
  transition: background 2s ease-in-out;
`;

export const TDSel = styled.td`
  max-width: 10%;
`;

export const TDLabel = styled.td`
  width: 30%;
`;

export const TDStatus = styled.td`
  max-width: 20%;
`;

export const TDACC = styled.td`
  min-width: 35%;
`;

export const StatusFormat = styled.span`
  padding: 0.2rem 0.7rem;
  border-radius: 0.2rem;
  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 0.74rem;
  line-height: 0.95rem;

  background-color: ${({ status }) =>
    status === "doing"
      ? "#F8E47C"
      : status === "pending"
        ? "#EFF1F5"
        : status === "done"
          ? "#118052"
          : "#FFBAAB"};

  color: ${({ status }) =>
    status === "doing"
      ? "#786A23"
      : status === "pending"
        ? "#7E858F"
        : status === "done"
          ? "#EFF1F5"
          : "#D93333"};
`;

export const SubTitle = styled.span`
  font-family: Sora;
  font-style: normal;
  font-weight: normal;
  font-size: 0.8rem;
  line-height: 1.125rem;

  color: #585e66;
  padding-top: 0.9375rem;
`;

export const CloseDiv = styled.div`
  svg {
    width: 0.75rem;
    height: 0.75rem;
    cursor: pointer;
  }

  &:hover {
    path {
      stroke: #40e5a0;
    }
  }
`;

export const Title = styled.span`
  font-family: Sora;
  font-style: normal;
  font-weight: 600;
  font-size: 1.125rem;
  line-height: 1.4375rem;
  color: #212326;
  padding-top: 1.875rem;
`;

export const DivIcon = styled.div`
  position: absolute;
  top: 1.125rem;
  right: 0.9375rem;
  cursor: pointer;

  svg {
    width: 0.75rem;
    height: 0.75rem;
    &:hover {
      path,
      rect {
        stroke: #40e5a0;
      }
    }
  }
`;
export const ButtonSpace = styled.div`
  display: flex;
  width: 20.7rem;
  justify-content: space-between;
  margin-right: 2rem;

  font-size: 1rem;
`;

export const Footer = styled.div`
  position: absolute;
  bottom: 0;
  padding: 1rem 0;
  border-top: 1.5px solid #c4c4c4;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;

  width: calc(100% - 1.77375rem);
`;
